import { IOrderDTO } from '../../lib/interfaces/Order';
import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';

const endpoints = {
	createPaymentSession: (data: FormData) => ({
		method: API_METHODS.POST,
		url: `${BASE_URL}/payment/product`,
		headers: createHeader(null, true),
		data,
	}),
	createSubscriptionPaymentSession: (data: IOrderDTO) => ({
		method: API_METHODS.POST,
		url: `${BASE_URL}/payment/subscription`,
		headers: createHeader(null, true),
		data,
	}),
};

export const createPaymentSession = async (
	data: FormData,
): Promise<{ url: string }> =>
	axiosRequest(endpoints.createPaymentSession(data));

export const createSubscriptionPaymentSession = async (
	data: IOrderDTO,
): Promise<{ url: string }> =>
	axiosRequest(endpoints.createSubscriptionPaymentSession(data));
